

module.exports = __webpack_require__.stylable.create(
    "Tooltip3582316473",
    {"classes":{"root":"Tooltip3582316473__root","popoverContent":"Popover2167784857__popoverContent","popover":"Popover2167784857__popover","arrow":"Popover2167784857__arrow","withArrow":"Popover2167784857__withArrow"},"vars":{},"stVars":{"contentArrowSize":"8px"},"keyframes":{}},
    "",
    3,
    "Tooltip3582316473",
    null
);
